import type { TFunction } from 'i18next'
import type { SupportedLanguage } from '../../../shared/i18n/i18n.no-deps'

export const arrayToReadableList = (
    array: string[],
    TFixed: (lng: string | readonly string[], ns?: string | readonly string[], keyPrefix?: string) => TFunction,
    language: SupportedLanguage
) =>
    array.reduce((output, item, index) => {
        if (index === 0) return item
        if (index === array.length - 1) {
            return `${output} ${TFixed(language)('appcore:common.and')} ${item}`
        }

        return `${output}, ${item}`
    }, '')
